export const LOCAL_STORAGE_API_KEY = 'API_KEY'
export const LOCAL_STORAGE_LOGIN_USER = 'LOGIN_USER'
export const LOCAL_STORAGE_CONFIG = 'CONFIG'

export const LOCAL_STORAGE_CASE_NUMBER = 'CASE_NUMBER_VALUE'
export const LOCAL_STORAGE_OIL_SUPPLY = 'OIL_SUPPLY_VALUE'
